import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import colors from '@app/constants/colors';

const Loader = ({ dotsColor }) => (
  <LoaderContainer>
    <Ellipsis
      dotsColor={dotsColor}
    >
      <div />
      <div />
      <div />
      <div />
    </Ellipsis>
  </LoaderContainer>
);

Loader.propTypes = {
  dotsColor: PropTypes.string,
};

Loader.defaultProps = {
  dotsColor: colors.ALICE_BLUE,
};

const LoaderContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`;

const LOADER_HEIGHT = 32;
const SMALL_LOADER_HEIGHT = 25;
const ELLIPSIS_SIZE = 11;

const Ellipsis = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: ${LOADER_HEIGHT}px;
  
  @media (max-width: 979px) {
     height: ${SMALL_LOADER_HEIGHT}px;
  }
  
  & div {
    position: absolute;
    top: ${(LOADER_HEIGHT - ELLIPSIS_SIZE) / 2}px;
    width: ${ELLIPSIS_SIZE}px;
    height: ${ELLIPSIS_SIZE}px;
    border-radius: 50%;
    background: ${({ dotsColor }) => dotsColor};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
    
    @media (max-width: 979px) {
     top: ${(SMALL_LOADER_HEIGHT - ELLIPSIS_SIZE) / 2}px;
  }
  }
  
  & div:nth-child(1) {
    left: 6px;
    animation: ellipsis1 0.6s infinite;
  }
  & div:nth-child(2) {
    left: 6px;
    animation: ellipsis2 0.6s infinite;
  }
  
  & div:nth-child(3) {
    left: 26px;
    animation: ellipsis2 0.6s infinite;
  }

  & div:nth-child(4) {
    left: 45px;
    animation: ellipsis3 0.6s infinite;
  }
  
  @keyframes ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }

  @keyframes ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
`;

export default Loader;
